import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { getCurrentLanguage } from '@/helpers/Utils';
import { getLabel } from '@/helpers/Utils';
import { firstListItem } from '@/constants/defaultValues';

export const fetchSubordinates = createAsyncThunk(
  'subordinates/fetchSubordinates',
  async (params, thunkAPI) => {
    try {
      const { id } = params;
      const response = await Lookup.GetAllSubordinates(id);
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label:
            item?.employeeWorkDetails?.employeeNo +
            ' | ' +
            getLabel(item.nameAr, item.nameEn),
          value: item.id,
          employeeNo: item?.employeeWorkDetails?.employeeNo,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  subordinatesList: [],
  loading: false,
  error: '',
};

const subordinatesSlice = createSlice({
  name: 'subordinates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubordinates.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubordinates.fulfilled, (state, action) => {
        state.loading = false;
        state.subordinatesList = action.payload;
        state.error = '';
      })
      .addCase(fetchSubordinates.rejected, (state, action) => {
        state.loading = false;
        state.subordinatesList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default subordinatesSlice.reducer;
